import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import axiosAuth from "../axiosAuth";
import { OWNERSHIP_CHANGE_PACKET } from "./apiRoutes";

interface UseGetOwnershipChangePacketHistoryProps {
  ocpId: string;
  data: any;
  queryParams?: Omit<UseQueryOptions, "queryKey">;
}

const getOwnershipChangePacketHistory = async (ocpId: string, data: any) =>
  await axiosAuth.post(`${OWNERSHIP_CHANGE_PACKET}/${ocpId}/history`, data);

const useGetOwnershipChangePacketHistory = ({
  ocpId,
  data,
  queryParams,
}: UseGetOwnershipChangePacketHistoryProps): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["ownership-change-packet-history", ocpId],
    queryFn: () => getOwnershipChangePacketHistory(ocpId, data),
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    ...queryParams,
    enabled: !!ocpId && (queryParams?.enabled ?? true),
  });
};

export default useGetOwnershipChangePacketHistory;
